module.exports = __webpack_public_path__ + "d1ade2831a8d57d9e7b2ad9728aaea71.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/sounds/owl-hoots/snowy_owl_hoot.mp3
// module id = 3273
// module chunks = 0